/* eslint-disable no-constant-condition */
import { useEffect, useState } from 'react';
import { NEW_STAFF } from '@/api/interface/staff';
import { useParams, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import API from '@/api/modules/staff';
import { half2all } from '@/utils/index';
import '@/scss/quill.bubble.css'; //富文本显示样式集合
import { setDocumentTitle } from '@/utils/index';
import { useThrottleFn } from 'ahooks';
import StaffEnd from './components/StaffEnd';
import { PARAMS } from './config';
import './index.scss';

const defaultData: NEW_STAFF = {
  activityId: '', //活动id
  storeId: '', //门店id
  storeName: '', //门店名称
  customerId: '', //员工工号
  customerName: '', //员工名称
};
const STORE_NAME = '职能部门';
const Index = () => {
  const params: Partial<PARAMS> = useParams();
  const navigate = useNavigate();

  //活动状态 1为开始 2结束
  const [_actStatus, setActStatus] = useState<number>(0);

  //活动状态 Y启动N停用
  const [_enable, setEnable] = useState<string>('Y');

  //一键生成二维码 是否点击
  const [_isClick, setIsClick] = useState<boolean>(false);

  //门店列表是否显示
  const [_showList, setShowList] = useState<boolean>(false);

  //门店列表-数据源
  const [_storeNameListSource, setStoreNameListSource] = useState<any>([]);

  //门店列表-显示
  const [_storeNameList, setStoreNameList] = useState<any[]>([]);

  //填写参数集合
  const [staffData, setStaffData] = useState<Partial<NEW_STAFF>>({
    ...defaultData,
    activityId: params.activityId,
  });

  //  初始化数据
  useEffect(() => {
    getActivity();
    getStoreServe();
  }, []);

  //底部按钮是否可点击
  useEffect(() => {
    // 判断是否能点击 一键生成二维码 按钮
    let flag = true;
    const _staffData: any = staffData;
    Object.keys(_staffData).forEach((key: string) => {
      if (!_staffData[key]) {
        flag = false;
      }
    });

    setIsClick(flag);
  }, [staffData]);

  // 获取所有门店列表
  const getStoreServe = async () => {
    const res = await API.findRetStoreName({
      storeName: '',
    });
    setStoreNameListSource(res);
  };

  //获取活动状态
  const getActivity = async () => {
    const res: any = await API.getActivityCommunityById({
      actId: staffData.activityId || '',
    });
    setEnable(res?.enable || 'N'); //活动状态
    setActStatus(res?.actStatus); //活动状态
    setDocumentTitle(res?.activityName); //设置活动标题
  };

  //模糊搜索门店名称列表
  const getStoreName = async (e: any) => {
    const val = e.target.value;
    setShowList(true);
    setStaffData({
      ...staffData,
      storeName: val,
      storeId: '', //清空上一次的门店
    });
    //搜索数据源
    const iptStoreName = half2all(val);
    const searchList = _storeNameListSource.filter((item: any) => {
      return item.storeName.indexOf(iptStoreName) != -1;
    });
    //组装数据
    const curList = searchList.map((item: any) => {
      return {
        ...item,
        iptStoreName,
      };
    });
    setStoreNameList(curList);
  };

  //组装门店列表显示
  const searchText = (res: any) => {
    if (res.iptStoreName && res.storeName.indexOf(res.iptStoreName) !== -1) {
      return res.storeName.replace(
        res.iptStoreName,
        `<font color="#f33429">${res.iptStoreName}</font>`
      );
    } else {
      return res.storeName;
    }
  };

  // 一键生成二维码
  const { run: createQrcode } = useThrottleFn(
    async () => {
      if (!_isClick) return;
      const staffDataCopy = {
        ...staffData,
        storeId: staffData.storeName === STORE_NAME ? '' : staffData.storeId,
        companyId: '1',
      };
      const staffId: any = await API.newStaff(staffDataCopy);
      navigate(`/staffQrcode/${staffDataCopy.activityId}/${staffId}`);
    },
    {
      wait: 500,
      trailing: false,
    }
  );

  //是否活动结束、为开始
  const showStatus = () => {
    if (_actStatus === 1 || _actStatus === 2 || _enable === 'N') return true;
  };

  //活动结束文案
  const showStatusTxt = () => {
    if (_actStatus === 1) {
      return '活动暂未开始';
    } else if (_actStatus === 2 || _enable === 'N') {
      return '活动已结束，感谢您的关注～';
    }
  };

  return (
    <>
      {!showStatus() ? (
        // 活动进行中
        <div
          className="staff"
          onClick={() => {
            //没有匹配门店 没有点击
            if (!staffData.storeId) {
              setStaffData({
                ...staffData,
                storeName: '',
                storeId: '',
              });
            }
            setShowList(false);
            setStoreNameList([]);
          }}
        >
          <div className="staff_ipt">
            <div className="staff_ipt_item">
              <img src={require('@/images/staff/icon_store.png')} alt="" />
              <input
                className="staff_ipt_input"
                onInput={(val) => getStoreName(val)}
                maxLength={30}
                value={staffData.storeName}
                onBlur={() => {
                  //没有搜索到匹配门店 清空输入框
                  if (_storeNameList && _storeNameList.length <= 0) {
                    setStaffData({
                      ...staffData,
                      storeName: '',
                      storeId: '',
                    });
                  }
                }}
                type="text"
                placeholder="请输入并选择店铺"
              ></input>
              {/* 门店搜索结果 */}
              {staffData?.storeName && _showList ? (
                <div className="staff_ipt_res">
                  {_storeNameList && _storeNameList.length > 0 ? (
                    <>
                      {_storeNameList.map((item, index) => (
                        <div
                          className="staff_ipt_res_item"
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            setStoreNameList([]);
                            setShowList(false);
                            setStaffData({
                              ...staffData,
                              storeName: item.storeName,
                              storeId:
                                item.storeName === STORE_NAME
                                  ? '99999999'
                                  : item.id, //默认写死一个值，假装跟别的门店数据一致
                            });
                          }}
                          dangerouslySetInnerHTML={{ __html: searchText(item) }}
                        ></div>
                      ))}
                    </>
                  ) : (
                    <div className="staff_ipt_res_empty">暂无搜索结果</div>
                  )}
                </div>
              ) : null}
            </div>
            <div className="staff_ipt_item">
              <img src={require('@/images/staff/icon_name.png')} alt="" />
              <input
                type="text"
                placeholder="请输入员工姓名"
                maxLength={40}
                onChange={(e) => {
                  const val = e.target.value;
                  setStaffData({
                    ...staffData,
                    customerName: val,
                  });
                }}
              />
            </div>
            <div className="staff_ipt_item">
              <img src={require('@/images/staff/icon_id.png')} alt="" />
              <input
                type="text"
                placeholder="请输入员工工号"
                maxLength={8}
                value={staffData.customerId}
                onChange={(e) => {
                  let val = e.target.value;
                  val = val.replace(/[^\d]/g, '');
                  setStaffData({
                    ...staffData,
                    customerId: val,
                  });
                }}
              />
            </div>
          </div>
          <div className="staff_tips"></div>
          <div
            className={classNames('staff_btn', _isClick ? 'active' : '')}
            onClick={createQrcode}
          >
            一键生成二维码
          </div>
        </div>
      ) : (
        // 活动结束
        <StaffEnd text={showStatusTxt()} />
      )}
    </>
  );
};

export default Index;
